import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
    myEventsSelector
} from "../store/selectors";

const Alert = () => {
    const isPending = useSelector(state => state.exchange.transaction.isPending);
    const isError = useSelector(state => state.exchange.transaction.isError);

    const alertRef = useRef(null);

    useEffect(() => {
        if (isPending || isError) {
            alertRef.current.className = 'alert';
        }
    }, [isPending, isError]);

    const removeHandler = () => {
        alertRef.current.className = 'alert--remove';
    }

    return (
        <div>
            {isPending && (
                <div ref={alertRef} onClick={removeHandler} className="alert alert--remove">
                    <h1>Transaction Pending...</h1>
                </div>
            )}
            {isError && (
                <div className="alert alert--remove" ref={alertRef} onClick={removeHandler}>
                    <h1>Transaction will Fail</h1>
                    <p>(Error: console.log F12)</p>
                </div>
            )}
        </div>
    );
}

export default Alert;
